export const locale = {
    lang: 'en',
    data: {
        'TITLE': {
        },
        'FIELDS': {
            'CoworkerRate': 'Coworker Rate',
        },
        'Message': {

        },
        'FILTERS': {
        },
        'Buttons': {
            'Save': 'Save',
        }
    }
};